const $ = window.jQuery;

export function checkField($field, cb) {
    // const fieldName = $field.attr('name');
    const fieldValue = $field.val();

    const isRequired = $field.data('f-required') === true;
    if (isRequired && !!fieldValue === false) {
        return false;
    }

    const isTel = $field.data('f-tel') === true;
    const phoneRegExp = /^(?:(\+1)(?:\D)?)?\(?(\d{3})\)?\D?(\d{3})\D?(\d{4})$/;
    if (isTel && !phoneRegExp.test(fieldValue)) {
        return false;
    }

    const isEmail = $field.data('f-email') === true;
    const emailRegExp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (isEmail && !emailRegExp.test(fieldValue)) {
        return false;
    }

    const fieldPattern = $field.data('f-pattern');
    const patternRexExp = new RegExp(fieldPattern);
    if (
        typeof fieldPattern !== 'undefined' &&
        !patternRexExp.test(fieldValue)
    ) {
        return false;
    }

    if (typeof cb === 'function' && cb(fieldValue) === false) {
        return false;
    }

    return true;
}

export function validateField($field, cb) {
    const $wrapper = $field.closest('.error-wrap');
    const isValid = checkField($field, cb);

    $wrapper.toggleClass('error', !isValid);

    return isValid;
}

export function validateForm($form) {
    let isValid = true;
    const $fields = $form.find(':input').toArray();

    $fields.forEach(field => {
        if (!validateField($(field))) {
            isValid = false;
        }
    });

    return isValid;
}

export function prepareFormValidation($form) {
    const $formFields = $form.find(':input').toArray();

    $formFields.forEach(field => {
        const $field = $(field);

        if ($field.is('[required]')) {
            $field.removeProp('required').data('f-required', true);
        }

        if ($field.is('[type=tel]')) {
            $field.data('f-tel', true);
        }

        if ($field.is('[type=email]')) {
            $field.data('f-email', true);
        }

        const pattern = $field.attr('pattern');
        if (typeof pattern === 'string') {
            $field.removeAttr('pattern').data('f-pattern', pattern);
        }
    });

    return function validate($passedForm) {
        let $formToValidate = $form;

        // If there is form passed to the function, this will
        // overwrite the original form intended to be checked.
        if (typeof $passedForm !== 'undefined') {
            $formToValidate = $passedForm;
        }

        const isFormValid = validateForm($formToValidate);

        return isFormValid;
    };
}

export function parseFormData($form) {
    const serializedArray = $form.serializeArray();
    const data = serializedArray.reduce((acc, field) => {
        acc[field.name] = field.value;

        return acc;
    }, {});

    return data;
}

export function getFormFields($form) {
    function FormFields() {
        this.fields = {};

        this.valid = () => {
            let result = true;

            Object.values(this.fields).forEach($field => {
                if (
                    $field.is('[required]') &&
                    ($field.val() === '' || $field.val() === null)
                ) {
                    result = false;

                    return false;
                }

                return true;
            });

            return result;
        };

        this.add = (name, field) => {
            this.fields[name] = field;
        };

        this.get = name => this.fields[name];

        this.values = () =>
            Object.entries(this.fields).reduce((values, [name, field]) => {
                // eslint-disable-next-line no-param-reassign
                values[name] = field.val();

                return values;
            }, {});
    }

    return $form
        .find(':input')
        .toArray()
        .reduce((form, current) => {
            if (current.name === '') {
                return form;
            }

            form.add(current.name, $(current));

            return form;
        }, new FormFields());
}
